import React from "react";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { formatLastFour, generateLoanDescription } from "../misc/messaging-utils";
import { AuthRestartButton } from "../misc/restart-button.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import { summarySubtitle } from "../misc/summary-subtitle.component";

export const AuthPaymentDebitSummary = (props) => {
  const subtitle = summarySubtitle(
    props.confirmationEmail,
    props.isPayoff,
    props.isPrincipalOnly,
    props.selectedLoan.NextDueDate
  );

  return (
    <AuthPaymentContainer
      title={props.isPayoff ? "Payoff Confirmation" : "Payment Summary"}
      subtitle={subtitle}
    >
      <div className="bold f20 text-centered">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <ReviewDisplayField title={"Payment Applied Date"} value={props.paymentAppliedDate} />
        <ReviewDisplayField
          title={"Payment Account"}
          value={props.paymentAccount}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
        <ReviewDisplayField title={"Convenience Fee"} value={props.fee} />
        <ReviewDisplayField
          title={"TOTAL PAYMENT"}
          value={props.paymentTotal}
          containerClassNames="total-payment"
        />
      </div>
      <AuthRestartButton backToLoans={props.backToLoans} bgColor={"#00558c"} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/summary/auth-payment-debit-summary.component.js